import { render } from "./Login.vue?vue&type=template&id=0cab4a8c"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=0cab4a8c&lang=scss"

import exportComponent from "F:\\Work\\Lu\\_pz\\pzvtour\\pzvtour-userbackend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__